
import utils from '@/utils';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Empty',
  methods: {
    btnAddClick() {
      utils.pageOpen('/my/create/empty');
    },
  },
});
